import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCabains } from '../../../../../appRedux/actions';

export const useCabains = (branchId, form) => {
  const dispatch = useDispatch();
  const { cabains } = useSelector((state) => state.cabain);

  const [treatmentTypeId, setTreatmentTypeId] = useState();

  useEffect(() => {
    if (branchId) {
      dispatch(getCabains({ branchId, status: 1 }));
    }
  }, [branchId, dispatch]);

  const onCabainChange = useCallback(
    (id) => {
      const cabain = cabains?.find((cabain) => cabain?.id === id);
      if (!cabain) return;

      const newTreatmentTypeId = cabain?.type?.treatmentType?.id;

      const currentTreatmentTypeId = form.getFieldValue('treatmentTypeId');

      if (currentTreatmentTypeId === newTreatmentTypeId) return;

      form.setFieldsValue({
        treatmentId: '',
        packageId: '',
        promoId: '',
        purchasedProductId: '',
        treatmentCategory: [''],
        treatmentTypeId: newTreatmentTypeId,
      });

      setTreatmentTypeId(newTreatmentTypeId);
    },
    [cabains, form]
  );

  const getCabainOptions = (appointmentId, treatmentTypeId) => {
    if (!cabains) return [];

    if (treatmentTypeId) {
      return cabains
        .filter((cabain) => cabain?.type?.treatmentType?.id === treatmentTypeId)
        .map((cabain) => ({
          value: cabain.id,
          label: cabain.name,
        }));
    }

    return cabains.map((cabain) => ({
      value: cabain.id,
      label: cabain.name,
    }));
  };

  return {
    cabains,
    treatmentTypeId,
    setTreatmentTypeId,
    onCabainChange,
    getCabainOptions,
  };
};
